// Colour helpers for the palette: reading a typed colour, and the HSV model the mixer works in.

// "#RGB" or "#RRGGBB", with or without the "#", in any case. Returns "#RRGGBB" in capitals, or null.
export const normaliseHex = (text) => {
  const t = String(text ?? '').trim().replace(/^#/, '');
  if (/^[0-9a-f]{3}$/i.test(t)) return ('#' + t.split('').map(c => c + c).join('')).toUpperCase();
  if (/^[0-9a-f]{6}$/i.test(t)) return ('#' + t).toUpperCase();
  return null;
};

// h in degrees (0 to 360); s and v from 0 to 1.
export const hexToHsv = (hex) => {
  const n = normaliseHex(hex) || '#FFFFFF';
  const r = parseInt(n.slice(1, 3), 16) / 255;
  const g = parseInt(n.slice(3, 5), 16) / 255;
  const b = parseInt(n.slice(5, 7), 16) / 255;
  const max = Math.max(r, g, b), d = max - Math.min(r, g, b);
  let h = 0;
  if (d) {
    if (max === r) h = ((g - b) / d) % 6;
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h = (h * 60 + 360) % 360;
  }
  return { h, s: max ? d / max : 0, v: max };
};

export const hsvToHex = ({ h, s, v }) => {
  const c = v * s;
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
  const m = v - c;
  const [r, g, b] = h < 60 ? [c, x, 0] : h < 120 ? [x, c, 0] : h < 180 ? [0, c, x]
    : h < 240 ? [0, x, c] : h < 300 ? [x, 0, c] : [c, 0, x];
  const part = (k) => Math.round((k + m) * 255).toString(16).padStart(2, '0');
  return ('#' + part(r) + part(g) + part(b)).toUpperCase();
};

// The dropper the pointer becomes while a colour is picked from the sheet. Its tip is the hotspot.
const DROPPER_SVG = "<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>"
  + "<line x1='14' y1='8' x2='5.5' y2='16.5' stroke='#fff' stroke-width='5' stroke-linecap='round'/>"
  + "<circle cx='17' cy='5' r='3.6' fill='#fff'/>"
  + "<line x1='14' y1='8' x2='5.5' y2='16.5' stroke='#222' stroke-width='2.4' stroke-linecap='round'/>"
  + "<circle cx='17' cy='5' r='2.6' fill='#222'/>"
  + "<path d='M5.5 16.5 L3 21 L7.5 18.5 Z' fill='#222' stroke='#fff' stroke-width='1' stroke-linejoin='round'/>"
  + "</svg>";
export const PICK_CURSOR = `url("data:image/svg+xml;utf8,${encodeURIComponent(DROPPER_SVG)}") 3 21, crosshair`;
